import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { Offer } from '../../../model/offer';
import { SharedService } from '../../../_services/shared.service';

import { UiNewOfferImageComponent } from '../ui-new-offer-image/ui-new-offer-image.component';
import { UiNewOfferIconComponent } from '../ui-new-offer-icon/ui-new-offer-icon.component';
import { UiNewOfferContentComponent } from '../ui-new-offer-content/ui-new-offer-content.component';
import { LxResponsiveClassDirective } from '../../../directives/lx-responsive-class.directive';
import { ThemeHighlightDirective } from '../../../directives/theme-highlight.directive';

@Component({
  selector: 'ui-new-offer-card',
  standalone: true,
  imports: [
    CommonModule,
    LxResponsiveClassDirective,
    UiNewOfferImageComponent,
    UiNewOfferIconComponent,
    UiNewOfferContentComponent,
    ThemeHighlightDirective,
  ],
  templateUrl: './ui-new-offer-card.component.html',
  styleUrl: './ui-new-offer-card.component.scss',
})
export class UiNewOfferCardComponent {
  readonly cardResponsiveClass = {
    horizontal: 'offer-card--desktop',
    vertical: 'offer-card--handset',
  } as const;

  @Input() offers!: Offer[] | null;
  @Input() offer!: Offer | null;
  @Input() index = 0;
  @Input() viewMoreToggle = false;
  @Input() propertyId = '';
  @Input() offerAliasId = '';
  @Input() viewMode: 'tiles' | 'list' = 'tiles';
  titlePopoverOpen = false;

  constructor(public sharedService: SharedService) {}

  get offerTitle(): string {
    return this.offer?.amenities?.upsell_room_name?.trim() ?? '';
  }

  openTitlePopover(): void {
    if (!this.offerTitle) return;
    this.titlePopoverOpen = true;
  }

  closeTitlePopover(): void {
    this.titlePopoverOpen = false;
  }

  toggleTitlePopover(event: Event): void {
    if (!this.offerTitle) return;
    event.preventDefault();
    event.stopPropagation();
    this.titlePopoverOpen = !this.titlePopoverOpen;
  }

  toggleFavorite(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (!this.offer?.offer_id) return;

    this.sharedService.toggleFavorite(this.offer.offer_id);

    // Notify home/filter panel to recompute filtered offers
    try {
      const evt = new CustomEvent('ui:new:favoritesChanged', {
        detail: { offerId: this.offer.offer_id, isFavorite: !!this.offer.flg_favorite },
        bubbles: true,
      });
      window.dispatchEvent(evt);
    } catch (e) {
      // ignore
    }
  }

  get isExpanded(): boolean {
    return this.sharedService.currentIndex === this.index && this.sharedService.currentIndex !== -1;
  }

  shouldShowStrike(offer: Offer | null): boolean {
    if (!offer || offer.bar_price == null || offer.ofr_price == null) {
      return false;
    }

    const bar = Number(offer.bar_price);
    const ofr = Number(offer.ofr_price);

    if (!isFinite(bar) || bar <= 0 || !isFinite(ofr)) {
      return false;
    }

    const discountPercent = ((bar - ofr) / bar) * 100;
    return discountPercent >= 5;
  }
}
